import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useMonitoringGoods } from './MonitoringContext';
import { LayoutTabSection as LayoutTab } from '../orders/_layouts/LayoutTabSection';
import { LayoutOrderContainer, LayoutTabSection } from '../orders/_layouts/LayoutOrderContainer';
import { ChevronLeft } from 'lucide-react';
import GoodsDetailSticky from './GoodsDetailSticky';
import { Dialog, DialogTrigger } from '@/components/atoms/Dialog';
import { Button } from '@/components/atoms/PcButton';
import RegisteredMonitoringEdit from './RegisteredMonitoringEdit';
import { useState } from 'react';
import { MOCK_GOODS } from './_mock/mockGoods';

const GoodsDetailAddKeyword = ({ isMockGoods }) => {
  const [searchParams] = useSearchParams();
  const goodsNo = searchParams.get('select');
  const [dialogOpen, setDialogOpen] = useState(false);
  const { goods, isLoading, isError } = useMonitoringGoods();

  const selectedGoods =
    goods.find((item) => String(item.GoodsNo) === String(goodsNo)) ||
    MOCK_GOODS.find((item) => String(item.GoodsNo) === String(goodsNo));
  return (
    <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
      <DialogTrigger asChild>
        <Button variant="default" className="h-[34px] px-[10px] py-[6px]">
          + 키워드 추가
        </Button>
      </DialogTrigger>
      <RegisteredMonitoringEdit
        goods={selectedGoods}
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
        isMockGoods={isMockGoods}
      />
    </Dialog>
  );
};

export default GoodsDetailAddKeyword;
